import { render, staticRenderFns } from "./OneSurveyRead.vue?vue&type=template&id=0dc03df8&scoped=true&"
import script from "./OneSurveyRead.vue?vue&type=script&lang=js&"
export * from "./OneSurveyRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc03df8",
  null
  
)

export default component.exports